import React from 'react'
import Layout from '../component/Layout/Layout'
import ProjectSlider from '../component/Project/Project'
import ContentHeader from './ContentHeader'

export default function Project() {
  return (
    <div id="PORTFOLIO">
      <Layout>
        <ContentHeader name={'My Projects'} />
        <ProjectSlider />
      </Layout>
    </div>
  )
}
